import { AxiosResponse } from 'axios';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { VehicleAutoCompleteResponse } from '@/main/models/response';
import { VehicleAutocompleteFilterRequest } from '@/main/models/request';

export abstract class IVehicleApi {
  abstract getVehicleAutocompletePartial(
    request: VehicleAutocompleteFilterRequest, cancelRequest: boolean
  ): Promise<AxiosResponse<PaginationResponse<VehicleAutoCompleteResponse>>>;

  abstract getVehicleAutocompleteFullWithYear(
    request: VehicleAutocompleteFilterRequest, cancelRequest: boolean
  ): Promise<AxiosResponse<PaginationResponse<VehicleAutoCompleteResponse>>>;
}
